/// <reference path="../../../../typings/index.d.ts" />


module Meevo.Plugins.YieldManagementStrategy {
    angular.module("meevo.plugins.yieldManagementStrategy", []);
}
